import fetch from "../../../utils/fetch";
import { urlBuilder } from "../../../helpers/url_builder_helper.js";

const stateInitial = {
  assignments: [],
  assignmentsIsLoading: false,
  assignmentsTotal: null,
  assignmentsPage: 1,
  assignmentsPerPage: 10,
  assignmentsError: null,
};

const getters = {
  assignments: (state) => state.assignments,
  assignmentsIsLoading: (state) => state.assignmentsIsLoading,
  assignmentsTotal: (state) => state.assignmentsTotal,
  assignmentsPage: (state) => state.assignmentsPage,
  assignmentsPerPage: (state) => state.assignmentsPerPage,
  assignmentsFrom: (state) => {
    return state.assignmentsTotal > 0
      ? (state.assignmentsPage - 1) * state.assignmentsPerPage + 1
      : 0;
  },
  assignmentsTo: (state) => {
    return state.assignmentsTotal > 0
      ? Math.min(state.assignmentsPage * 10, state.assignmentsTotal)
      : 0;
  },
  assignmentsError: (state) => state.assignmentsError,
};

const t = {
  LOCATIONS_RESET_ASSIGNMENTS: "LOCATIONS_RESET_ASSIGNMENTS",
  LOCATION_SET_ASSIGNMENTS_LOADING: "LOCATION_SET_ASSIGNMENTS_LOADING",
  LOCATION_SET_ASSIGNMENTS: "LOCATION_SET_ASSIGNMENTS",
  LOCATION_SET_ASSIGNMENTS_ERROR: "LOCATION_SET_ASSIGNMENTS_ERROR",
  LOCATION_SET_ASSIGNMENTS_PAGE: "LOCATION_SET_ASSIGNMENTS_PAGE",
  LOCATION_SET_ASSIGNMENTS_PER_PAGE: "LOCATION_SET_ASSIGNMENTS_PER_PAGE",
};

const actions = {
  async fetchAssignments({ commit, state }, ctx) {
    commit(t.LOCATION_SET_ASSIGNMENTS_LOADING, ctx);
    return fetch("/areas/" + state.id + "/assigned_locations" + urlBuilder(ctx))
      .then((response) => response.json())
      .then((data) => {
        commit(t.LOCATION_SET_ASSIGNMENTS, data);
      })
      .catch((e) => {
        commit(t.LOCATION_SET_ASSIGNMENTS_ERROR, e.message);
      });
  },
  deleteAssignment({ dispatch }, assignment) {
    return fetch(assignment["@id"], {
      method: "DELETE",
    })
      .then((response) => {
        return response.status === 204;
      })
      .then((isDeleted) => {
        return isDeleted;
      })
      .catch((error) => {
        commit(types.LOCATION_SET_ASSIGNMENTS_ERROR, error);
      });
  },
};

const mutations = {
  [t.LOCATIONS_RESET_ASSIGNMENTS](state) {
    state = stateInitial;
  },
  [t.LOCATION_SET_ASSIGNMENTS_LOADING](state) {
    state.assignmentsIsLoading = true;
    state.assignmentsError = null;
  },
  [t.LOCATION_SET_ASSIGNMENTS](state, response) {
    state.assignments = response["hydra:member"];
    state.assignmentsTotal = response["hydra:totalItems"];
    state.assignmentsIsLoading = false;
    state.assignmentsError = null;
  },
  [t.LOCATION_SET_ASSIGNMENTS_ERROR](state, error) {
    state.assignmentsError = error;
    state.assignmentsIsLoading = false;
  },
  [t.LOCATION_SET_ASSIGNMENTS_PAGE](state, page) {
    state.assignmentsPage = page;
  },
  [t.LOCATION_SET_ASSIGNMENTS_PER_PAGE](state, perPage) {
    state.assignmentsPerPage = perPage;
  },
};

export default {
  state: stateInitial,
  getters,
  actions,
  mutations,
};
